import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card, Row, Col, Button, Input, Table } from 'reactstrap';
import DatePicker from 'react-datepicker';


import ActionCard from '../../../components/Footer/ActionCard';
import { UpdateEditRestriction } from '../../../store/action-restriction/actions';
import { GetPlanId, NoOfDays, NoOfWeeks } from '../../../helpers/Helpers';

import InfoIcon from '../../../assets/images/icons/info.svg';
import styles from './style.module.scss';

import { IPWConfigData, IPWConfigPayload } from '../../../interfaces/plan-window-configuration.interface';
import { GetPWConfigData, UpdatePWConfigData } from '../../../api-services/sales-plan.api';

interface OwnProps {
  history: any;
  isCallRequired: boolean;
  onLoadEnd: () => void;
  onUpdateStart: () => void;
  onUpdateEnd: () => void;
}

interface StateProps {
  history: any;
  isAllowed: boolean;
  filterData: any;
}

interface DispatchProps {
  UpdateEditRestriction: (isAllowed: boolean) => void;
}

type Props = StateProps & DispatchProps & OwnProps;


interface State {
  isLoading: boolean;
  dataSource: any;
  originalDataSource: any;
}


class PlanningWindowConfigurationTable extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      originalDataSource: { columns: [], rows: [] },
      dataSource: { columns: [], rows: [] }
    };
  }

  componentDidMount(): void {
    this.getPWConfigData();
  }

  componentDidUpdate(prevProps, prevState): void {
    if (!prevProps.isCallRequired && this.props.isCallRequired) {
      this.setState({
        isLoading: true
      }, () => {

        this.getPWConfigData();
      });
    }
  }

  getPWConfigData(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    GetPWConfigData(params)
      .then((res: IPWConfigData) => {
        this.setState({
          originalDataSource: !!res ? res : { columns: [], rows: [] },
          isLoading: false
        }, () => {
          this.dataInit(true);
          this.props.onLoadEnd();
        });
      });
  }

  dataInit(isNew: boolean): void {
    const data: IPWConfigData = JSON.parse(JSON.stringify(this.state.originalDataSource));//dummyData
    const dataSource: IPWConfigData = {
      columns: data.columns.map((column) => {
        return {
          ...column
        };
      }),
      rows: data.rows.map((row, rIdx) => {
        return {
          ...row
        };
      })
    };
    this.setState({ dataSource })
  }

  updatePWConfigData() {
    const payload: IPWConfigPayload = { row: [] };
    payload.row = this.state.dataSource.rows.filter((row) => row.isEdited);

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname)
    };

    this.props.onUpdateStart();

    UpdatePWConfigData(payload, params)
      .then((res) => {
        if (!!res) {
          this.props.onUpdateEnd();
          this.props.UpdateEditRestriction(false);
        }
      });
  }

  onUpdateCheckbox(e, rowIdx: number, fieldName: string): void {
    this.state.dataSource.rows[rowIdx][fieldName].value = e.target.checked;
    this.state.dataSource.rows[rowIdx][fieldName].isSeasonEdited = true;
    this.state.dataSource.rows[rowIdx].isEdited = true;
    this.setState({ dataSource: this.state.dataSource });
  }

  onUpdateDate(inputDate: Date, rowIdx, fieldName: string, type: string): void {
    this.state.dataSource[rowIdx][fieldName] = [
      inputDate.getMonth() + 1,
      inputDate.getDate(),
      inputDate.getFullYear()
    ].join('-');

    if (type === 'PLANNING PERIOD') {
      this.state.dataSource[rowIdx].planningPeriodNoOfDays =
        NoOfDays(this.state.dataSource[rowIdx].planningPeriodStartDate, this.state.dataSource[rowIdx].planningPeriodEndDate);
      this.state.dataSource[rowIdx].planningPeriodNoOfWeeks =
        NoOfWeeks(this.state.dataSource[rowIdx].planningPeriodStartDate, this.state.dataSource[rowIdx].planningPeriodEndDate);
    }

    if (type === 'CORRESP PERIOD') {
      this.state.dataSource[rowIdx].corPeriodNoOfWeeks =
        NoOfWeeks(this.state.dataSource[rowIdx].corPeriodStartDate, this.state.dataSource[rowIdx].corPeriodEndDate);
    }

    if (type === 'NEXT PERIOD') {
      this.state.dataSource[rowIdx].nextPeriodNoOfWeeks =
        NoOfWeeks(this.state.dataSource[rowIdx].nextPeriodStartDate, this.state.dataSource[rowIdx].nextPeriodEndDate);
    }

    this.setState({ dataSource: this.state.dataSource });
  }

  render(): React.ReactNode {

    const bodySection = <div>

      <Card className="section-header-card">
        <Row className="align-items-center">
          <Col md={4}>

            <div className="d-flex">
              <p className="table-title">Planning Window Configuration
                <span className="sub-title"> ({this.state.dataSource.rows.length})</span>
              </p>
              <img src={InfoIcon} alt="info-icon" className="cursor-pointer"/>
            </div>

          </Col>
        </Row>
      </Card>

      <div className={`table-responsive table-outline custom-table ${styles['season-table']}`}>
        <table className="mb-0 w-100">
          <thead>
          <tr className="text-center">
            {
              this.state.dataSource.columns.map((row, rowIdx: number) => (
                <React.Fragment key={rowIdx}>
                  <th colSpan={row.colspanHdr.length}>
                    {row.header}
                  </th>

                </React.Fragment>
              ))

            }
          </tr>
          <tr>
            {
              this.state.dataSource.columns.map((row, rowIdx: number) => (
                <React.Fragment key={rowIdx}>

                  {
                    row.colspanHdr.map((colVal: string, wIdx: number) => (
                      <th key={wIdx}>{colVal}</th>
                    ))
                  }

                </React.Fragment>
              ))

            }
          </tr>
          </thead>
          <tbody>
          {
            this.state.dataSource.rows.map((row, idx: number) => (
              <React.Fragment key={idx}>
                <tr>
                  <td>{row.quarter}</td>
                  <td>
                    <DatePicker
                      selected={new Date(row.planningPeriodStartDate)}
                      // onChange={(date: Date) => this.onUpdateDate(date, idx, 'planningPeriodStartDate', 'PLANNING PERIOD')}
                      dateFormat="dd MMM yy"
                      maxDate={new Date(row.planningPeriodEndDate)}
                      className="date-input"
                      disabled
                    /></td>
                  <td>
                    <DatePicker
                      selected={new Date(row.planningPeriodEndDate)}
                      // onChange={(date: Date) => this.onUpdateDate(date, idx, 'planningPeriodEndDate', 'PLANNING PERIOD')}
                      dateFormat="dd MMM yy"
                      minDate={new Date(row.planningPeriodStartDate)}
                      className="date-input"
                      disabled
                    /></td>
                  <td>{NoOfWeeks(row.planningPeriodStartDate, row.planningPeriodEndDate)}</td>
                  <td
                    className={`${styles['border-right']}`}>{NoOfDays(row.planningPeriodStartDate, row.planningPeriodEndDate)}</td>
                  <td><Input
                    type="checkbox"
                    checked={row.activePreSeason.value}
                    onChange={(e) => this.onUpdateCheckbox(e, idx, 'activePreSeason')}
                  /></td>
                  <td><Input
                    type="checkbox"
                    checked={row.activeInSeason.value}
                    onChange={(e) => this.onUpdateCheckbox(e, idx, 'activeInSeason')}
                  /></td>
                </tr>
              </React.Fragment>
            ))
          }
          </tbody>
        </table>
      </div>
    </div>;

    return (
      <React.Fragment>
        {bodySection}
        <ActionCard
          onCancel={() => {
            this.dataInit(false);
          }}
          onSave={() => {
            this.updatePWConfigData();
          }}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any): StateProps => {
  return {
    ...state.EditRestriction,
    filterData: state.FilterData
  };
};

export default connect<StateProps, DispatchProps, OwnProps>
(mapStateToProps, {
  UpdateEditRestriction
})(withRouter(PlanningWindowConfigurationTable));